import React from 'react';
import { useTranslation } from 'react-i18next';
import { FilterOption } from '../../../types';
import { CommonModelsWrapper } from './ModelFamilySelector.style';
import CheckboxSelector from '../../CheckboxComponent';
import { AvailableFiltersCount } from '../../../types/oneGraphTypes';

interface CommonModelsFilter {
  commonModelFamilyOptions: {
    [key: string]: AvailableFiltersCount;
  };
  selectedModelFamilyFilters: string[];
  filterType: string;
  onChange: (newValue: string) => void;
}

const CommonModelsList: React.FC<CommonModelsFilter> = ({
  commonModelFamilyOptions,
  selectedModelFamilyFilters,
  filterType,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <CommonModelsWrapper data-testid="common-model-list-group">
      {Object.keys(commonModelFamilyOptions).map((option) => {
        const model = commonModelFamilyOptions[option];
        return (
          <CheckboxSelector
            inputName={`common-${model.value}`}
            key={model.value}
            onChange={() => onChange(model.value)}
            value={model.value}
            checked={selectedModelFamilyFilters.includes(model.value)}
            disabled={model.disabled}
            filterType={filterType}
          />
        );
      })}
    </CommonModelsWrapper>
  );
};

export default CommonModelsList;
